<template>
  <b-overlay :show="isLoading">
    <div class="card p-1 rounded-lg">
      <div class="d-flex justify-content-between align-items-center">
        <p class="mb-0 text-hede">
          <i class="far fa-ticket-alt text-primary" /> ซื้อสลาก <small>(เครดิต)</small>
        </p>
      </div>

      <div class="my-50">
        <small>ยอดเงิน (บาท)</small>
        <h3 class="mb-25 font-weight-bolder text-primary">
          {{ sum }}
          <span style="font-size: 0.95rem">THB</span> |
          {{ count }}
          <span style="font-size: 0.95rem">ใบ</span>
        </h3>
      </div>

      <!-- <hr>

      <div class="my-50">
        <small>ยอดเงิน (วอน)</small>
        <h3 class="mb-25 font-weight-bolder text-primary">
          {{ sumKR }}
          <span style="font-size: 0.95rem">KRW</span> |
          {{ countKR }}
          <span style="font-size: 0.95rem">ใบ</span>
        </h3>
      </div> -->
    </div>
  </b-overlay>
</template>


<script>
import {
  BSpinner, BRow, BCol, BOverlay,
} from 'bootstrap-vue'

export default {
  components: {
    BSpinner, BRow, BCol, BOverlay,
  },
  data() {
    return {
      isLoading: false,
      todayBonus: 0,
      todayBonusKR: 0,
      count: 0,
      countKR: 0,
      sum: 0,
      sumKR: 0,
    }
  },
  mounted() {
    this.getData('TODAY_LOTTO_CREDIT');
  },
  methods: {
    async getData(type) {
      this.isLoading = true;
      try {
        const { data } = await this.$http.get(`/dashboard?type=${type}`);

        this.todayBonus = data.todayBonus;
        this.todayBonusKR = data.todayBonusKR;
        this.count = data.count;
        this.countKR = data.countKR;
      } catch (error) {
        console.log(error);
      } finally {

        this.isLoading = false;
      }
    }
  }
}
</script>